/**
 * Parses tags from a URL search parameter value.
 *
 * Handles multiple formats:
 * - Comma-separated string: "tag1,tag2"
 * - Stringified array with single quotes: "['tag1','tag2']"
 * - Stringified array with double quotes: '["tag1","tag2"]'
 * - Already an array: ["tag1", "tag2"]
 */
export function parseTagsParam(value: unknown): string[] | null {
  if (!value) return null

  if (Array.isArray(value)) {
    return value.length > 0 ? value : null
  }

  const str = String(value).trim()
  if (!str) return null

  let tags: string[]

  if (str.startsWith("[") && str.endsWith("]")) {
    const inner = str.slice(1, -1)
    tags = inner
      .split(",")
      .map((t) => t.trim().replace(/^['"]|['"]$/g, ""))
      .filter(Boolean)
  } else {
    tags = str.split(",").filter(Boolean)
  }

  return tags.length > 0 ? tags : null
}
